// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b3-4";
export var closeButton = "_b3-6";
export var dismissButton = "_b3-3";
export var editImageWithAiContainer = "_b3-8";
export var imageUploadWrapper = "_b3-7";
export var misspelledWord = "_b3-5";
export var spellCheckContainer = "_b3-2";
export var spin = "_b3-1";
export var spinning = "_b3-0";